import React, { useState } from 'react';
import './BanUserModal.css';

interface BanUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onBan: (reason: string, duration: number) => void;
  username: string;
}

const BanUserModal: React.FC<BanUserModalProps> = ({ isOpen, onClose, onBan, username }) => {
  const [reason, setReason] = useState('');
  const [duration, setDuration] = useState('24');
  const [isClosing, setIsClosing] = useState(false);

  if (!isOpen && !isClosing) return null;

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
      setReason('');
      setDuration('24');
    }, 300);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedReason = reason.trim();
    const durationNum = parseInt(duration);
    
    if (trimmedReason.length < 5) {
      return;
    }
    
    if (durationNum < 1 || durationNum > 8760) {
      return;
    }
    
    onBan(trimmedReason, durationNum);
    handleClose();
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div className={`ban-modal-backdrop ${isClosing ? 'closing' : ''}`} onClick={handleBackdropClick}>
      <div className={`ban-modal ${isClosing ? 'closing' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="ban-modal-header">
          <h2>Ban User</h2>
          <button className="ban-close-btn" onClick={handleClose}>×</button>
        </div>
        
        <div className="ban-modal-body">
          <p className="ban-username">Banning: <strong>{username}</strong></p>
          
          <form onSubmit={handleSubmit}>
            <div className="ban-form-group">
              <label>Reason</label>
              <input
                type="text"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Enter ban reason (5-500 characters)..."
                required
                minLength={5}
                maxLength={500}
                autoFocus
              />
            </div>
            
            <div className="ban-form-group">
              <label>Duration (hours)</label>
              <input
                type="number"
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                min="1"
                max="8760"
                required
              />
              <small className="ban-form-hint">
                {parseInt(duration) >= 24 
                  ? `${Math.floor(parseInt(duration) / 24)} day${Math.floor(parseInt(duration) / 24) !== 1 ? 's' : ''}`
                  : `${duration} hour${duration !== '1' ? 's' : ''}`
                }
              </small>
            </div>
            
            <div className="ban-modal-actions">
              <button type="button" className="ban-btn-cancel" onClick={handleClose}>
                Cancel
              </button>
              <button type="submit" className="ban-btn-submit">
                Ban User
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BanUserModal;
